import React from "react";
import { useDispatch, useSelector } from "react-redux";

import BiometricMovementAndCautionQuestionContainer
    from "../shared/MovementModal/BiometricMovementAndCautionQuestionContainer";
import {
    setOpenBiometricMovementAndCautionQuestionContainer,
} from "../../features/editAssessment/editAssessmentSlice";
import CONSTANT from "../../constants/Constant";
import useEditAssessmentHeaderAndFooter from "./hooks/useEditAssessmentHeaderAndFooter";
import crossBtn from "../../assets/img/utils/cross.svg";
import {getMarkup} from "../../utils/Utils";
import './EditAssessmentDialogContainer.scss';

const EditAssessmentDialogContainer = () => {
    const { handleSetShowInstruction } = useEditAssessmentHeaderAndFooter();
    const dispatch = useDispatch();
    const editAssessmentState = useSelector(state => state.editAssessment);
    const baseData = editAssessmentState?.baseData;
    const groups = editAssessmentState?.groups || [];

    const openBiometricMovementAndCautionQuestionContainer = baseData?.openBiometricMovementAndCautionQuestionContainer;
    const testId = baseData?.testId || '';
    const bodyRegionList = baseData?.bodyRegionList || [];
    const showInstruction = baseData?.showInstruction;

    const currentGroupId = baseData?.currentGroupId || CONSTANT.ASSESSMENT_GROUP.DEMOGRAPHICS.key;
    const currentGroup = groups.find(group => group.groupId === currentGroupId);


    const handleOpenBiometricModal = (value) => {
        dispatch(setOpenBiometricMovementAndCautionQuestionContainer(value));
    }

    return (
        <>
            {openBiometricMovementAndCautionQuestionContainer &&
                <BiometricMovementAndCautionQuestionContainer
                    data={{
                        testId,
                        selectedBodyRegions: { bodyRegionList : bodyRegionList },
                        openBiometricMovementAndCautionQuestionContainer,
                    }}
                    setOpenBiometricMovementAndCautionQuestionContainer={handleOpenBiometricModal}
                />
            }


            {showInstruction && (
                <div className="modal-overlay" onClick={() => handleSetShowInstruction(false)}>
                    <div 
                        className="edit-assessment-dialog-container__modal--large edit-assessment-dialog-container__instruction-container"
                        onClick={(e) => e.stopPropagation()} // Prevent closing when clicking inside modal
                    >
                        <div className="edit-assessment-dialog-container__instruction-header-content">
                            <p className="edit-assessment-dialog-container__instruction-header-content-title">{currentGroup?.groupName}</p>
                            <img 
                                onClick={() => handleSetShowInstruction(false)} 
                                className="edit-assessment-dialog-container__close-button" 
                                src={crossBtn} 
                                alt="Close Button" 
                            />
                        </div>
                        <label 
                            className="edit-assessment-dialog-container__instruction-info"  
                            dangerouslySetInnerHTML={getMarkup(currentGroup?.groupCompleted ? currentGroup?.completedGroupHeaderTitle : currentGroup?.groupTitle)}
                        />
                    </div>
                </div>
            )}
        </>
    )
}

export default EditAssessmentDialogContainer;